import { BaseService } from './BaseService';

export interface Service {
  id: string;
  category: string;
  category_name?: string;
  name: string;
  slug: string;
  description: string;
  icon_url: string;
  base_price: number | null;
  duration_minutes: number | null;
  is_active: boolean;
  display_order: number;
  created_at?: string;
  updated_at?: string;
}

export interface ServiceListResponse {
  items: Service[];
  total_count: number;
  page: number;
  limit: number;
  total_pages: number;
}

class ServiceService extends BaseService {
  private baseUrl = '/services/admin/services';

  /**
   * List all services with optional category filter
   */
  async listServices(
    page: number = 1,
    limit: number = 10,
    search: string = '',
    categoryId: string = ''
  ): Promise<ServiceListResponse> {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('limit', limit.toString());
    if (search) {
      params.append('search', search);
    }
    if (categoryId) {
      params.append('category', categoryId);
    }

    return this.get<ServiceListResponse>(
      `${this.baseUrl}?${params.toString()}`
    );
  }

  /**
   * Get a single service
   */
  async getService(id: string): Promise<Service> {
    return this.get<Service>(`${this.baseUrl}/${id}/`);
  }

  /**
   * Create a new service
   */
  async createService(data: Partial<Service>): Promise<Service> {
    return this.post<Service>(`${this.baseUrl}/`, data);
  }

  /**
   * Update a service
   */
  async updateService(id: string, data: Partial<Service>): Promise<Service> {
    return this.patch<Service>(`${this.baseUrl}/${id}/`, data);
  }

  /**
   * Delete a service
   */
  async deleteService(id: string): Promise<void> {
    await this.delete<void>(`${this.baseUrl}/${id}/`);
  }
}

export default new ServiceService();
